// extracted by mini-css-extract-plugin
module.exports = {"Subtitle":"Subtitle_Subtitle__3MeVX"};